import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slot"]

  selectAll(event) {
    event.preventDefault()
    this.setSlots(this.slotTargets, true)
  }

  clearAll(event) {
    event.preventDefault()
    this.setSlots(this.slotTargets, false)
  }

  toggleWeekday(event) {
    event.preventDefault()
    const weekday = String(event.params.weekday)
    const slots = this.slotTargets.filter((slot) => slot.dataset.weekday === weekday)

    this.toggleSlots(slots)
  }

  toggleDate(event) {
    event.preventDefault()
    const date = String(event.params.date)
    const slots = this.slotTargets.filter((slot) => slot.dataset.date === date)

    this.toggleSlots(slots)
  }

  toggleRange(event) {
    event.preventDefault()
    const rangeId = String(event.params.rangeId)
    const slots = this.slotTargets.filter((slot) => slot.dataset.rangeId === rangeId)

    this.toggleSlots(slots)
  }

  toggleSlots(slots) {
    const shouldCheck = slots.some((slot) => !slot.checked)
    this.setSlots(slots, shouldCheck)
  }

  setSlots(slots, checked) {
    slots.forEach((slot) => {
      slot.checked = checked
      slot.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
}
